module.exports = __webpack_public_path__ + "static/media/varal-individual-parede.8ff88c72.png";